module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/mobileAppSheetCat-91b956320babeecdd6f0912b29a07de7.png";